import React, { useEffect, useReducer, createContext } from "react";

import currencyReducer from "../reducers/currency-reducer";
import { setCurrency } from "../actions";

export const CurrencyContext = createContext();
const CurrencyProvider = CurrencyContext.Provider;

export function CurrencyWrapper({ children }) {
  const defaultCurrency = React.useMemo(
    () => ({ country: "United Kingdom", codeISO: "GBP" }),
    []
  );

  const storedCurrency =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("currency"))
      : null;

  const [currency, dispatchCurrency] = useReducer(
    currencyReducer,
    storedCurrency || defaultCurrency
  );

  // Cache currency in localStorage when it changes
  useEffect(() => {
    if (currency) {
      localStorage.setItem("currency", JSON.stringify(currency));
    }
  }, [currency]);

  // Dispatch default currency if no stored currency exists
  useEffect(() => {
    if (!storedCurrency) {
      dispatchCurrency(setCurrency(defaultCurrency));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contextValue = React.useMemo(
    () => ({ currency, dispatchCurrency, defaultCurrency }),
    [currency, defaultCurrency]
  );

  return <CurrencyProvider value={contextValue}>{children}</CurrencyProvider>;
}
